import BaseService from './_base.service';

export const diameterService = {
    page,
    combo,
    search,
    edit,
    create,
    one,
    remove,
    removeLogic
};

function page(page,size, callback) {
    return BaseService.get("/lens/attr/diameter/page/"+page+"/"+size, callback, true)
}

function search(page,size,filter, callback) {
    return BaseService.post("/lens/attr/diameter/page/"+page+"/"+size,filter, callback, true)
}
function combo(callback) {
    return BaseService.get("/lens/attr/diameter/combo/", callback, true)
}

function edit(id, bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.put("/lens/attr/diameter/"+id, body, callback, true)
}

function create(bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.post("/lens/attr/diameter/", body, callback, true)
}

function one(id,callback) {
    return BaseService.get("/lens/attr/diameter/one/"+id, callback);
}

function remove(id,callback) {
    return BaseService.delete("/lens/attr/diameter/"+id, callback);
}

function removeLogic(id,callback) {
    return BaseService.delete("/lens/attr/diameter/"+id+"/logic", callback);
}
